/**
 * The Learn pages' shelves — a heading over a short grid of course cards
 * (Courses' Start here / Going deeper, My learning's Pick up next,
 * Certificates' Almost there) — and the results grid the Courses hub shows
 * while a filter or search is on (the same `SHELF_GRID`). A `.ts` sibling so
 * the shelf, the results grid and the skeletons that stand in for them share
 * one set of classes and cannot drift: a pending page then has the loaded
 * page's shape at every width.
 *
 * Both sit in ScreenLayout's main-column `@container`, so the steps are
 * `@`-queries on the column's own width (the sidebar and the Mitra panel
 * narrow it independently of the window), not window breakpoints.
 */

/** A shelf is one row of the grid: at most this many cards, the widest the grid gets. */
export const SHELF_MAX = 4

/**
 * 2 / 4 across, for shelves and for the results grid alike (a filtered hub, My
 * learning's tabs), so a page never shows two card sizes. Two-up from a phone
 * (a one-card column would make four shelves of four cards a screen each), and
 * no 3-up step: a four-card shelf would orphan its fourth card on a second row
 * there, so a grid goes from two-by-two straight to rows of four. The four-up
 * step is `@3xl` (768px): the main column is 844px wide beside the sidebar and the right
 * rail, and four cards of about 200px there is the shelf the design draws,
 * where two-up would stretch each thumbnail past 400px. rest:ln: 24 apart across too, the mock's
 * `ln-cards` gap (266 cards at a 1440 window, now the column is full width).
 */
export const SHELF_GRID = 'grid grid-cols-2 gap-6 @3xl:grid-cols-4'

/**
 * A drill-down page's two columns — a step, a dictionary word: the page's own
 * panels over two thirds of the column, the aside (what to do next, where to
 * see it) over the third. One column below `@3xl`. The wide column is the
 * first child, which takes `PRIMARY_COLUMN`.
 */
export const TWO_COLUMNS = 'grid grid-cols-1 gap-6 @3xl:grid-cols-3 @3xl:items-start'

export const PRIMARY_COLUMN = '@3xl:col-span-2'
